import { useState } from "react";
import {
  Box,
  FormHelperText,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { Moment } from "moment";
import { FieldError } from "react-hook-form";
import { theme } from "../../../../utils";

type CustomTimeFieldProps = {
  label: string;
  value: Moment;
  format: string;
  ampm: boolean;
  error?: FieldError;
  onChange: (value: Moment) => void;
  onShowList: () => void;
};

export const CustomTimeField = ({
  label,
  value,
  format,
  ampm,
  error,
  onChange,
  onShowList,
}: CustomTimeFieldProps) => {
  const [inputValue, setInputValue] = useState<Moment | null>(value);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        position: "relative",
      }}
    >
      <Typography sx={{ mb: "4px" }}>
        {label}
        <Box component="span" sx={{ color: theme.palette.error.main }}>
          &nbsp;*
        </Box>
      </Typography>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <TimeField
          value={inputValue}
          onChange={(nextValue: Moment | null) => {
            setInputValue(nextValue);
            if (nextValue?.isValid()) onChange(nextValue);
          }}
          format={format}
          ampm={ampm}
          autoFocus
          fullWidth
          slotProps={{ textField: { error: !!error } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={`Choose ${label.toLowerCase()} from list`}
                  size="small"
                  edge="end"
                  onClick={onShowList}
                >
                  <ArrowDropDownIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ "& .MuiInputBase-input": { padding: "0.5rem" } }}
        />
      </LocalizationProvider>
      {error && (
        <FormHelperText
          error
          sx={{ position: "absolute", left: 0, bottom: "-24px" }}
        >
          {error.message}
        </FormHelperText>
      )}
    </Box>
  );
};
